import React, { useEffect, useRef, useState } from 'react';
import { heroContent } from '../mock';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [scroll, setScroll] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const onScroll = () => setScroll(Math.min(1, window.scrollY / (window.innerHeight || 1)));
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section ref={ref} className="relative min-h-[100vh] w-full overflow-hidden text-white">
      {/* Background image with parallax scale */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${heroContent.bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'grayscale(1) brightness(0.35) contrast(1.05)',
          transform: `scale(${1 + scroll * 0.15}) translateY(${scroll * 40}px)`,
          transition: 'transform 120ms linear',
          willChange: 'transform',
        }}
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-[#050506]/70 via-[#050506]/40 to-[#050506]"
        style={{ opacity: 0.6 + scroll * 0.4 }}
      />
      <div className="halftone-strong" />

      {/* Content with scroll fade */}
      <div
        className="relative z-10 mx-auto max-w-[1400px] px-6 min-h-[100vh] flex flex-col justify-between gap-10 pt-[120px] md:pt-[140px] pb-14"
        style={{
          opacity: 1 - scroll * 0.8,
          transform: `translateY(${-scroll * 40}px)`,
        }}
      >
        <div className="fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="pill"><span className="dot-live" />AGENTIC AI · v0.4 · WHATSAPP LIVE</span>
            <span className="mono text-[11px] text-white/40 uppercase tracking-widest hidden md:inline">
              grocery retail / multi-location
            </span>
          </div>
          <h1 className="h-display text-white text-[54px] sm:text-[68px] md:text-[92px] max-w-[900px]">
            {heroContent.title}
          </h1>
        </div>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div className="max-w-md fade-up delay-2">
            <p className="text-[15px] leading-[1.55] text-white/70 mb-8">
              {heroContent.description}
            </p>
            <a
              href="https://calendar.app.google/rUCGByUhUwE69b2T9"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              {heroContent.cta} <ArrowRight size={16} />
            </a>
          </div>

          <div className="fade-up delay-3 flex flex-col gap-3 min-w-[280px]">
            <div className="h-px bg-white/25" />
            <div className="flex items-start justify-between gap-6">
              <span className="eyebrow flex items-center gap-2">
                <span className="dot-live" />
                {heroContent.eyebrow}
              </span>
              <span className="mono text-[11px] text-white/50 whitespace-nowrap">now · live</span>
            </div>
            <div className="mono text-[10.5px] text-white/45 tracking-wider">
              <span className="blink">auto-replenishing 6 branches now</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
